export default "__VITE_ASSET__CoDuDMrd__"